import React from "react";

import { Link } from "react-router-dom";


function NavbarAdmissions() {


  return (
    <div className="Navbar d-print-none">
      <>
       
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
  <div className="container">
  <a className="navbar-brand" href="#">
  <img
                      src="/assets/images/logo.png"
                      className="main-logo"
                      lt="logo" width={250}
                    />
</a>

    <button
      className="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span className="navbar-toggler-icon" />
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
       
        <li className="nav-item">
        <div className="contact">
  <a href="tel:+91 63576 75561"  className=" text-dark">
  <h5><i class="ri-phone-fill me-3"></i>+91 63576 75561/2/3{" "}</h5>
  </a>

  <a href="tel:+91 1800 203 7800" className=" text-dark">
 <h5> <i class="ri-customer-service-2-fill me-3"></i> Toll Free 1800 203 7800</h5>
  </a>
</div>

        </li>
      </ul>
      
    </div>
  </div>
</nav>

      </>
    </div>
  );
}

export default NavbarAdmissions;
